import Chapter from "./Chapter";
import { motion } from "framer-motion";
import { Check } from "lucide-react";

const OFFERS = [
  {
    name: "Démonstration",
    desc: "Essai sur votre site ou en visio.",
    price: "Gratuit",
    cta: "Réserver une démo",
    featured: false,
    features: [
      "Présentation complète du produit",
      "Test sur vos véhicules / cas réels",
      "Échange avec un expert technique",
      "Étude de votre besoin",
    ],
  },
  {
    name: "Achat",
    desc: "La plateforme, livrée et prise en main.",
    price: "Sur devis",
    cta: "Demander un devis",
    featured: true,
    features: [
      "Plateforme Sapeur-360 complète",
      "Formation des opérateurs incluse",
      "Garantie & maintenance",
      "Pièces et accessoires d'origine",
      "Support technique dédié",
    ],
  },
  {
    name: "Location & flotte",
    desc: "Pour collectivités et pros multi-sites.",
    price: "Sur mesure",
    cta: "Nous contacter",
    featured: false,
    features: [
      "Location courte ou longue durée",
      "Déploiement multi-sites",
      "Contrat de maintenance",
      "Conditions adaptées aux marchés publics",
    ],
  },
];

export default function Offres() {
  return (
    <section id="offres" data-testid="offers-section" className="py-24 lg:py-32 bg-[#FAFAFA] border-t border-zinc-200">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="max-w-2xl">
          <Chapter index={6} label="Acquisition" />
          <h2 className="font-display mt-4 text-3xl md:text-4xl font-bold tracking-tight">
            Choisissez la formule adaptée à votre activité.
          </h2>
          <p className="mt-4 text-lg text-[#52525B]">
            Achat, location ou déploiement de flotte : on construit l'offre avec vous.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 lg:grid-cols-3 gap-6">
          {OFFERS.map((p, i) => (
            <motion.div
              key={p.name}
              data-testid={`offer-card-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className={`flex flex-col bg-white border rounded-sm p-8 transition-all duration-300 hover:-translate-y-1 hover:shadow-md ${
                p.featured ? "border-zinc-300 border-t-2 border-t-[#E63946] shadow-sm" : "border-zinc-200"
              }`}
            >
              {p.featured && (
                <span className="self-start mb-4 font-mono-tech text-[11px] uppercase tracking-wider bg-[#E63946] text-white px-2.5 py-1 rounded-sm">
                  Le plus demandé
                </span>
              )}
              <h3 className="font-display text-xl font-bold tracking-tight">{p.name}</h3>
              <p className="mt-1.5 text-sm text-[#52525B]">{p.desc}</p>
              <div className="mt-6">
                <span className="font-display text-4xl font-black tracking-tight">{p.price}</span>
              </div>

              <ul className="mt-6 space-y-3 flex-1">
                {p.features.map((f) => (
                  <li key={f} className="flex items-start gap-2.5 text-sm text-[#52525B]">
                    <Check className="h-4 w-4 mt-0.5 text-[#E63946] shrink-0" strokeWidth={2.5} />
                    {f}
                  </li>
                ))}
              </ul>

              <a
                data-testid={`offer-cta-${i}`}
                href="#contact"
                className={`mt-8 inline-flex items-center justify-center font-bold px-6 py-3 rounded-sm transition-colors duration-300 ${
                  p.featured
                    ? "bg-[#E63946] hover:bg-[#BE123C] text-white"
                    : "border border-zinc-300 hover:border-[#0A0A0A] text-[#0A0A0A]"
                }`}
              >
                {p.cta}
              </a>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
